import { render, staticRenderFns } from "./IssueMultipleModal.vue?vue&type=template&id=31f32c34&scoped=true"
import script from "./IssueMultipleModal.vue?vue&type=script&lang=js"
export * from "./IssueMultipleModal.vue?vue&type=script&lang=js"
import style0 from "./IssueMultipleModal.vue?vue&type=style&index=0&id=31f32c34&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31f32c34",
  null
  
)

export default component.exports